import type { CSSProperties } from "react"

/** Sticky name column sizing for economics tables.
 *
 *  - `STICKY_NAME_COL` goes on the `<td>` / `<th>` and prevents the column from
 *    collapsing in `table-layout: auto` (where text columns get squeezed by
 *    numeric ones).
 *  - `STICKY_NAME_COL_INNER_MAX` must be applied to a block element INSIDE
 *    the cell, because auto-layout tables ignore max-width on `<td>`.
 *    Wrap text content in `<div style={STICKY_NAME_COL_INNER_MAX}>...</div>`
 *    to enforce the upper bound.
 */
export const STICKY_NAME_COL: CSSProperties = { minWidth: 320 }
export const STICKY_NAME_COL_INNER_MAX: CSSProperties = { maxWidth: 600 }
